import type { components } from '@/api/generated/schema';

export type UserRole = components['schemas']['PixlideDomainIdentityEnumsUserRole'];
export type UserStatus = components['schemas']['PixlideDomainIdentityEnumsUserStatus'];

/**
 * Libellés des rôles et statuts d'utilisateur, partagés par la liste transverse
 * (« Utilisateurs ») et par la fiche d'un tenant.
 *
 * Regroupés ici plutôt que recopiés dans chaque page : ces valeurs traduisent des énumérations
 * du domaine (`UserRole`, `UserStatus`), et deux copies finiraient par diverger — un même
 * compte apparaîtrait « Éditeur » sur un écran et « Editor » sur l'autre.
 */
export const ROLE_LABELS: Record<UserRole, string> = {
  0: 'Lecture seule',
  1: 'Éditeur',
  2: 'Manager',
  3: 'Propriétaire',
  100: 'Admin plateforme',
};

/**
 * Rôles attribuables à un utilisateur de tenant, du plus au moins privilégié.
 * `PlatformAdmin` (100) en est volontairement absent : il ne s'obtient ni par invitation ni
 * depuis cet écran, seulement par création ou promotion depuis « Équipe ».
 */
export const TENANT_ROLES: readonly UserRole[] = [3, 2, 1, 0];

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
  0: 'Email non confirmé',
  1: 'Actif',
  2: 'Désactivé',
};

export const USER_STATUS_TONES: Record<UserStatus, 'neutral' | 'success' | 'warning' | 'danger'> = {
  0: 'neutral',
  1: 'success',
  2: 'danger',
};
